import { render, staticRenderFns } from "./IconVideoSm.vue?vue&type=template&id=4123fc42&"
import script from "./IconVideoSm.vue?vue&type=script&lang=js&"
export * from "./IconVideoSm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4123fc42')) {
      api.createRecord('4123fc42', component.options)
    } else {
      api.reload('4123fc42', component.options)
    }
    module.hot.accept("./IconVideoSm.vue?vue&type=template&id=4123fc42&", function () {
      api.rerender('4123fc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVideoSm.vue"
export default component.exports